import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext({ level: 4, showAll: true, setShowAll: () => {}, data: null, reload: () => {} });
const KEY = "aegis-show-all-modules";

export const OnboardingProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [showAll, setShow] = useState(() => localStorage.getItem(KEY) === "on");
  const reload = useCallback(() => api.get("/onboarding").then((r) => setData(r.data)).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  const setShowAll = (v) => { setShow(v); localStorage.setItem(KEY, v ? "on" : "off"); };
  return <Ctx.Provider value={{ data, level: data?.level ?? 4, showAll, setShowAll, reload }}>{children}</Ctx.Provider>;
};

export const useOnboarding = () => useContext(Ctx);

export const askMariUrl = (q) => `/app/mari?ask=${encodeURIComponent(q)}`;
